import { Form, FormInstance, Select } from "antd";
import { useCallback, useMemo } from "react";
import { IOption } from "../../../../../../../types/Option";

type TaxTypeSelectProps = {
  form: FormInstance;
};

export const TaxTypeSelect = ({ form }: TaxTypeSelectProps) => {
  const options: IOption[] = useMemo(
    () => [
      {
        label: "SSN",
        value: 1,
      },
      {
        label: "EIN",
        value: 2,
      },
    ],
    []
  );

  const onChange = useCallback(
    () => form.setFieldValue("taxId", undefined),
    [form]
  );

  return (
    <Form.Item name="taxIdType" label="Tax ID" className="mb-0 tax-type-select">
      <Select options={options} onChange={onChange}></Select>
    </Form.Item>
  );
};
